export default {"src":"/_next/static/media/fatal-accident.94cd2edf.svg","height":34,"width":24,"blurWidth":0,"blurHeight":0};